import React, { FC } from 'react'
import { useDispatch } from 'react-redux'
import { MyOfficeProps as Props } from './types'
import { pageRemoveOffice, pageAddOtherOffice, pageChangeOffice } from '../../../../../../../store/pages-management/actions'

const MyOffice: FC<Props> = ({ strings, location }) => {
  const dispatch = useDispatch()

  return (
    <div>
      { location.my_office?.locations.map((address, index, addresses) => {
        return (
          <div className="columns" key={ index }>
            <div className="column is-12">
              <label>{ strings.address }</label>
              { addresses.length > 1 &&
              <button
                className="button"
                onClick={ () => dispatch(pageRemoveOffice(index)) }
                style={{ float: 'right' }}
              >
                { strings.remove }
              </button>
              }

              <input
                type="text"
                className="grey full-width"
                onChange={ (e) => dispatch(pageChangeOffice(index, e.target.value)) }
                value={ address }
              />
            </div>
          </div>
        )
      }) }

      <button className="button" onClick={ () => dispatch(pageAddOtherOffice()) } style={{ marginTop: '10px' }}>
        { strings.add_another_office }
      </button>
    </div>
  )
}

export default MyOffice